import React from 'react';
import { ErrorBoundaryTW } from '../../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import classNames from 'classnames';

interface MetricCardProps {
  href: string;
  title: string;
  data: string | number;
  icon: React.ReactNode;
  iconClassName?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({ href, title, data, icon, iconClassName = 'bg-blue-500' }) => {
  return (
    <ErrorBoundaryTW>
      <div className={'flex-1 overflow-hidden rounded-2xl border-[1px] border-gray-200 bg-white '}>
        <div className={'flex flex-row items-center gap-4 p-4'}>
          <div className={classNames(`h-12 w-12 rounded-full p-1`, iconClassName)}>{icon}</div>
          <div>
            <div className={'text-base'}>{title}</div>
            <div className={'text-3xl font-semibold'}>{data}</div>
          </div>
        </div>
        <div className={'bg-gray-100 px-4 py-3'}>
          <a
            href={href}
            className={'cursor-pointer text-blue-600 hover:text-black hover:underline'}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            View All
          </a>
        </div>
      </div>
    </ErrorBoundaryTW>
  );
};
